import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.41 12l4.3-4.29a1.004 1.004 0 10-1.42-1.42L12 10.59l-4.29-4.3a1.004 1.004 0 00-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 000 1.42 1 1 0 001.42 0l4.29-4.3 4.29 4.3a1 1 0 001.42 0 1 1 0 000-1.42L13.41 12z",
			fillRule: "nonzero"
		})
	})
});
export { SvgClose as ReactComponent };
